import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  Divider,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { People } from '~/services/Http';

import { EmployeeInfo } from './components/EmployeeInfo';
import { EmployeeTopInfo } from './components/EmployeeTopInfo';
import { EmploymentInfo } from './components/EmploymentInfo';
import { useSxStyles } from './useStyles';

export interface Props {
  employee: People.EmployeeProfileDto;
}

export const EmployeeDialogContent: React.FC<Props> = ({ employee }) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  return (
    <>
      <DialogContent sx={sxStyles.dialogContentRoot}>
        <EmployeeTopInfo employee={employee} />
        <Divider sx={sxStyles.divider} />
        <Box sx={sxStyles.dialogBottomInfo}>
          <Box sx={sxStyles.employeeInfoContainer} data-cy="employee-info">
            <EmployeeInfo employee={employee} />
          </Box>
          <Box data-cy="employment-info">
            <EmploymentInfo employee={employee} />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          href={`/page-ui2-redirect?empId=${employee.id}&area=people`}
          data-cy="view-full-profile"
        >
          {t('viewFullProfile')}
        </Button>
      </DialogActions>
    </>
  );
};
